<dynamic-form
  *ngIf="columns && columns.length > 0"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="HrmTaxTable"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content">
    <editable-grid
      [columns]="HrmTaxTableDetails"
      (valueChanges)="valueChanges($event)"
      [DefaultValues]="DefaultValues"
      [(dataList)]="model.HrmTaxTableDetails">
    </editable-grid>
  </ng-container>
</dynamic-form>
